<!-- TODOS ADD REMOVE splitlayout for layout switch-->
<div class="col-lg-12" [ngClass]="showPdfViewer ? 'splitlayout' : ''">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span class="d-flex justify-content-between align-items-center pt-0 pb-3">
        <span class="col-auto">
          <h2 class="mb-0">
            Invoice Review Summary {{ clientName }}
            <!-- <jni-spinner *ngIf="showSmallLoader"></jni-spinner> -->
          </h2>
        </span>

        <span class="d-flex gap-3 customizefilter-btn align-items-center">
          <div
            class="ordersummary-total ordersummary-col d-flex align-items-center align-items-center">
            <span> Preview: </span>
            <label class="ms-2 radiobtnholder">
              <p-radiobutton
                inputId="On"
                class="me-2"
                [value]="true"
                [(ngModel)]="showPdfViewer"
                (onClick)="onReviewChange(true)" />
              On
            </label>
            <label class="ms-2 radiobtnholder">
              <p-radiobutton
                inputId="Off"
                class="me-2"
                [(ngModel)]="showPdfViewer"
                [value]="false"
                (onClick)="onReviewChange(false)" />
              Off
            </label>
          </div>
          <div
            class="ordersummary-status ordersummary-col d-flex align-items-center gap-2">
            <h3 class="mb-0">Ready For Billing Review:</h3>
            <b class="px-1">
              <p-checkbox
                [(ngModel)]="defaultInvoiceReviewStatus"
                [binary]="true"
                (onChange)="onCheckboxChange()">
              </p-checkbox>
            </b>
            <b class="px-1">
              <p-button
                label="{{ submitButtonLabel }}"
                [class.primarybtn]="true"
                [class.bluebtn]="submitButtonColor === 'blue'"
                [class.greenbtn]="submitButtonColor === 'green'"
                (click)="submitInvoiceReviewStatus()"
                [disabled]="submitButtonDisabled" />
            </b>
          </div>

          <span class="cross-border" (click)="onCloseModalEvent()"
            ><i class="pi pi-times"></i
          ></span>
        </span>
      </span>

      <div class="adduser-container-hgt">
        <div class="d-flex gap-3">
          <div class="col-lg col-sm-8">
            <div
              class="invoicepreviewsummary"
              [ngClass]="showPdfViewer ? 'splitlayout' : ''">
              <div class="content">
                <div class="detailsection">
                  <jni-invoice-review-order-details
                    [salesOrderId]="saleOrderId"
                    (updatePdfEvent)="updatePdfEvent()">
                  </jni-invoice-review-order-details>
                </div>

                <div class="cstm-collaspse">
                  <p-panel
                    class="collapseable zeroHeight"
                    [toggleable]="true"
                    [collapsed]="collapseOrderLineDetailsStatus"
                    (onBeforeToggle)="onOrderLineDetailsToggle()"
                    [collapseIcon]="'pi pi-angle-double-up'"
                    [expandIcon]="'pi pi-angle-double-down'"
                    [ngClass]="{ active: collapseOrderLineDetailsStatus }">
                    <ng-template pTemplate="header">
                      <header
                        class="align-items-center d-flex has-border ordersummary-header gap-3">
                        <h3 class="mb-0">Order Line Details</h3>
                        <a
                          class="mb-0 ms-5 btncommitSyle"
                          *ngIf="
                            (invoiceReviewLines?.Lines?.length ?? 0 > 12) &&
                            !showLessOrderLinesSection
                          "
                          (click)="sellAllOrderLineDetails()">
                          More Sell Lines Exist
                          <a
                            class="ms-1 btncommitSyle"
                            *ngIf="
                              (invoiceReviewLines?.Lines?.length ?? 0 > 12) &&
                              !showLessOrderLinesSection
                            "
                            (click)="sellAllOrderLineDetails()"
                            >(See All)</a
                          >
                        </a>

                        <a
                          class="mb-1 ms-5 btncommitSyle"
                          *ngIf="showLessOrderLinesSection"
                          (click)="showLessOrderLines()">
                          Show Less Lines
                        </a>
                        <div
                          class="ordersummary-panel ml-auto d-flex justify-content-between marginleft-auto">
                          <div
                            class="form-check form-switch d-flex align-items-center m-0 justify-content-end">
                            <p-toggleswitch
                              (onChange)="includeNetOnlyLines($event)"
                              id="flexSwitchCheckDefault2"
                              name="flexSwitchCheckDefaul2" />
                            <label
                              class="form-check-label mx-2"
                              for="flexSwitchCheckDefault2">
                              Include Net Only Lines
                            </label>
                          </div>
                          <div
                            class="ms-3 nav-link p-0 d-flex align-items-center">
                            <a class="link" (click)="exportExcel()"
                              ><i class="pi pi-cloud-download"></i> Export
                              excel</a
                            >
                          </div>
                        </div>
                      </header>
                    </ng-template>
                    <ng-template #icons>
                      <div class="collapse-section border-0">
                        <a
                          class="btn-collapse"
                          (click)="onOrderLineDetailsToggle()"
                          [ngClass]="{ active: collapseOrderLineDetailsStatus }"
                          >{{ collapseOrderLineDetailsHeading }}</a
                        >
                      </div>
                    </ng-template>
                    <jni-invoice-review-order-line-details
                      [orderLineDetailsGridListing]="
                        orderLineDetailsGridListing
                      "
                      (vendorInvoiceEvent)="vendorInvoiceSelection()"
                      [invoiceReviewLines]="invoiceReviewLines"
                      [orderLineDetailsConsumesMessage]="
                        orderLineDetailsConsumesMessage
                      "
                      [isFromIpSummary]="true">
                    </jni-invoice-review-order-line-details>
                  </p-panel>
                </div>

                <div class="cstm-collaspse">
                  <p-panel
                    class="collapseable zeroHeight"
                    [toggleable]="true"
                    [collapsed]="collapseNotesStatus"
                    (onBeforeToggle)="onNotesToggle()"
                    [collapseIcon]="'pi pi-angle-double-up'"
                    [expandIcon]="'pi pi-angle-double-down'"
                    [ngClass]="{ active: collapseNotesStatus }">
                    <ng-template #header>
                      <header
                        class="align-items-center d-flex has-border mt-3 ordersummary-header pb-2">
                        <h3 class="m-0 wordwrap sec-title">Notes</h3>

                        <div
                          class="ordersummary-panel ml-auto d-flex justify-content-between">
                          <div
                            class="ms-3 nav-link p-0 d-flex align-items-center">
                            <a class="link" (click)="openSideBarForOrderNotes()"
                              ><i class="pi pi-plus"></i> New</a
                            >
                          </div>
                        </div>
                        <div
                          class="ordersummary-panel ml-auto d-flex justify-content-between">
                          <div
                            class="ms-3 nav-link p-0 d-flex align-items-center">
                            <i class="icon-Edit me-2"></i>
                            <a
                              class="link"
                              (click)="updateSideBarForOrderNotes()"
                              ><i class="pi pi-pen-to-square"></i> Edit</a
                            >
                          </div>
                        </div>
                        <div
                          class="ordersummary-panel ml-auto d-flex justify-content-between">
                          <div
                            class="ms-3 nav-link p-0 d-flex align-items-center">
                            <i class="icon-Delete me-2"></i>
                            <a
                              class="link delcol"
                              (click)="deleteSideBarForOrderNotes()"
                              ><i class="pi pi-trash"></i> Delete</a
                            >
                          </div>
                        </div>
                      </header>
                    </ng-template>
                    <ng-template #icons>
                      <div
                        class="collapse-section border-0 marginleft-auto d-flex gap-3">
                        <a class="link" (click)="exportExcelForNotes()"
                          ><i class="pi pi-cloud-download"></i> Export excel</a
                        >
                        <a
                          class="btn-collapse"
                          (click)="onNotesToggle()"
                          [ngClass]="{ active: collapseNotesStatus }"
                          >{{ collapseNotesHeading }}</a
                        >
                      </div>
                    </ng-template>
                    <jni-invoice-review-order-notes
                      #ordernotes
                      [saleOrderId]="saleOrderId"
                      [isFromInvoiceSummary]="true"
                      [orderNotesGridListing]="orderNotesGridListing"
                      (selectedOrderNotesListing)="updateLineOnSideBar($event)">
                    </jni-invoice-review-order-notes>
                  </p-panel>
                </div>

                <!-- ngIf is false as IN IR Dynamics don't have any Order Tracking -->

                <!-- ngIf is false as IN IR Dynamics don't have any Order Tracking -->
                <div class="cstm-collaspse">
                  <p-panel
                    class="collapseable zeroHeight"
                    [toggleable]="true"
                    [collapsed]="collapseOrderTrackingStatus"
                    (onBeforeToggle)="onOrderTrackingToggle()"
                    [collapseIcon]="'pi pi-angle-double-up'"
                    [expandIcon]="'pi pi-angle-double-down'"
                    [ngClass]="{ active: collapseOrderTrackingStatus }">
                    <ng-template #header>
                      <header
                        class="align-items-center d-flex has-border ordersummary-header">
                        <h3 class="mb-0">Order Tracking</h3>
                        <div
                          class="ordersummary-panel ml-auto d-flex justify-content-between">
                          <div
                            class="ms-3 nav-link p-0 d-flex align-items-center">
                            <a class="link" (click)="sellAllOrderTracking()"
                              >See All</a
                            >
                          </div>
                        </div>
                      </header>
                    </ng-template>
                    <ng-template #icons>
                      <div
                        class="collapse-section border-0 marginleft-auto gap-3 d-flex">
                        <a class="link" (click)="exportExcelForOrderTracking()"
                          ><i class="pi pi-cloud-download"></i> Export excel</a
                        >
                        <a
                          class="btn-collapse"
                          (click)="onOrderTrackingToggle()"
                          [ngClass]="{ active: collapseOrderTrackingStatus }"
                          >{{ collapseOrderTrackingHeading }}</a
                        >
                      </div>
                    </ng-template>
                    <jni-invoice-review-order-tracking
                      [orderTrackingGridListing]="orderTrackingGridListing"
                      [calculateTotalForAllLines]="true"
                      [salesId]="saleOrderId"
                      [projId]="projId"
                      (scrollHiddenStatus)="addScollHiddenClass()">
                    </jni-invoice-review-order-tracking>
                  </p-panel>
                </div>

                <div class="cstm-collaspse">
                  <p-panel
                    class="collapseable zeroHeight"
                    [toggleable]="true"
                    [collapsed]="collapseInvoiceEmailStatus"
                    (onBeforeToggle)="onInvoiceEmailToggle()"
                    [collapseIcon]="'pi pi-angle-double-up'"
                    [expandIcon]="'pi pi-angle-double-down'"
                    [ngClass]="{ active: collapseInvoiceEmailStatus }">
                    <ng-template #header>
                      <header
                        class="align-items-center d-flex has-border ordersummary-header">
                        <h3 class="mb-0">Invoice Email</h3>
                        <div
                          class="ordersummary-panel ml-auto d-flex justify-content-between"></div>
                      </header>
                    </ng-template>
                    <ng-template #icons>
                      <div class="collapse-section border-0">
                        <a
                          class="btn-collapse"
                          (click)="onInvoiceEmailToggle()"
                          [ngClass]="{ active: collapseInvoiceEmailStatus }"
                          >{{ collapseInvoiceEmailHeading }}
                        </a>
                      </div>
                    </ng-template>
                    <div class="row">
                      <div class="col-6 removepaddingtopinvoiceemail">
                        <jni-invoice-review-invoice-emails
                          #invoiceEmail
                          [invoiceEmailListing]="invoiceEmailListing"
                          (invoiceEmailAddEvent)="invoiceEmailAdd()"
                          (invoiceEmailCopyBacEmailEvent)="
                            invoiceEmailCopyBacEmailEvent($event)
                          "
                          (invoiceEmailCopyBcEmailEvent)="
                            invoiceEmailCopyBcEmailEvent($event)
                          "
                          (invoiceEmailAddBcBacEmailEvent)="
                            invoiceEmailAddBcBacEmailEvent($event)
                          "
                          (invoiceEmailDeletedEvent)="
                            invoiceEmailDelete($event)
                          "
                          (invoiceEmailEditEvent)="invoiceEmailEdit($event)"
                          (invoiceEmailSaveEvent)="
                            saveInvoiceEmailModel($event)
                          ">
                        </jni-invoice-review-invoice-emails>
                      </div>
                      <div class="col-6">
                        <div class="mt-1">
                          <div
                            class="d-flex align-items-center justify-content-between mb-2">
                            <h3 class="mb-0">Quick Note</h3>

                            <p-button label="Send" (click)="onQuickQuote()" />
                          </div>
                          <textarea
                            pInputText
                            name=""
                            id=""
                            cols="30"
                            rows="10"
                            style="height: 90px; width: 100%"
                            [(ngModel)]="quickQuote"></textarea>
                        </div>
                      </div>
                    </div>
                  </p-panel>
                </div>
              </div>
            </div>

            <jni-print-purchase-order
              [saleOrderId]="saleOrderId"
              [printPdfModal]="printPdfModal"
              [purchaseOrderLine]="purchaseOrderLine"
              (openPdfScreenModalEvent)="openPdfScreen($event)"
              (closePrintPdfModalEvent)="closePrinfPdfModal()">
            </jni-print-purchase-order>

            <jni-order-notes-sidebar
              #ordernotessidebar
              [isFromInvoiceSummary]="true"
              [(display)]="displaySidebar"
              [saleOrderId]="saleOrderId"
              [displaySideBeforeSubmittingStatus]="
                displaySideBeforeSubmittingStatus
              "
              (refreshOrderNotesGrid)="getSalesOrderNotes(saleOrderId)"
              (closeSidebar)="
                closeSideBarForOrderNotes()
              "></jni-order-notes-sidebar>

            <jni-modal-stacker
              *ngIf="orderTrackingModalStatus"
              [displayModal]="orderTrackingModalStatus"
              (closeEvent)="closeModalForOrderTracking()">
              <h1 class="panelHeading">Order Tracking Listing</h1>
              <div class="panelBody">
                <jni-invoice-review-order-tracking
                  [salesId]="saleOrderId"
                  [projId]="projId"
                  (scrollHiddenStatus)="addScollHiddenClass()"
                  (closeModalEvent)="closeModalForOrderTracking()"
                  [forModalStacker]="true"></jni-invoice-review-order-tracking>
              </div>
            </jni-modal-stacker>

            <jni-modal-stacker
              *ngIf="orderLinesDetailModalStatus"
              [displayModal]="orderLinesDetailModalStatus"
              (closeEvent)="closeModalForOrderLineDetails()">
              <h1 class="panelHeading">Order Lines Details Listing</h1>
              <div class="panelBody">
                <jni-invoice-review-order-line-details
                  (scrollHiddenStatus)="addScollHiddenClass()"
                  [invoiceReviewLines]="invoiceReviewLines"
                  [orderLineDetailsConsumesMessage]="
                    orderLineDetailsConsumesMessage
                  "></jni-invoice-review-order-line-details>
              </div>
            </jni-modal-stacker>
          </div>

          <div class="pdfsection">
            <ngx-extended-pdf-viewer
              [base64Src]="reportBase64String"
              [textLayer]="true"
              [showHandToolButton]="true"
              [showPresentationModeButton]="true"
              [zoom]="pdfZoom"
              class="pdf-wdth"
              *ngIf="showPdfViewer"></ngx-extended-pdf-viewer>
          </div>
        </div>
      </div>
    </p-card>
  </div>
</div>
